module.exports = __webpack_public_path__ + "videos/waterfall.207c2ed.mp4";